import React, {fetchStockFundamentals} from "../../api";
import {useState,useEffect} from "react";
import DisplayCards from "../metricCards";
import Plot from "react-plotly.js";
import { Sparklines, SparklinesLine } from 'react-sparklines';
import {useNavigate} from "react-router-dom";

const FundaTeaser = ({symbol}) => {

  const [metrics, setMetrics] = useState({});
  const [ratio_metrics, setRatioMetrics] = useState({});
  const [pnl_metrics, setPnlMetrics] = useState({});
  const [asset_metrics, setAssetMetrics] = useState({});
  const [metricListPie, setMetricListPie] = useState({});
  const [metricListSl, setMetricListSl] = useState({});

  const [latestDate, setLatestDate] = useState(null);
  const navigate = useNavigate();

  const transformData = (data) => {
     // Extract the latest available date dynamically
     const availableDates = Object.values(data)
      .map(item => Object.keys(item).filter(key => key !== "change"))
      .flat();

     const latest = availableDates.length ? availableDates[0] : null;
      const totalAssets = parseFloat(data["Assets"]?.[latest]) || 0;
      console.log("latestDate",latest,totalAssets)
      // Extract all keys except "Assets"
      const assetKeys = Object.keys(data).filter(key => key !== "Assets");

      // Calculate individual asset values
      const transformedList = assetKeys.map(key => ({
        title: key,
        value: parseFloat(data[key][latest]) || 0
      }));

      // Calculate "Others" as Total Assets - Sum of other asset categories
      const sumOfKnownAssets = transformedList.reduce((sum, item) => sum + item.value, 0);
      const otherAssets = totalAssets - sumOfKnownAssets;

      // Include "Others" if it's greater than zero
      if (otherAssets > 0) {
        transformedList.push({ title: "Others", value: otherAssets });
      }

      return transformedList;
};
const AssetDonutChart = ({ assetList }) => {
  // Extracting labels and values from assetList
  const labels = assetList.map((item) => item.title);
  const values = assetList.map((item) => item.value);

  return (
    <Plot
      data={[
        {
          labels: labels,
          values: values,
          type: "pie",
          hole: 0.4, // Creates the donut effect
          marker: {
            colors: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A569BD"],
          },
          textinfo: "label+percent",
          hoverinfo: "label+value",
        },
      ]}
      layout={{
        title: "Asset Allocation",
        height: 400,
        width: 400,
        showlegend: false,
      }}
    />
  );
};

 useEffect(() => {
    // fetch(url)  // Adjust API URL as needed
    //   .then(response => response.json())
     fetchStockFundamentals(symbol,'all')
      .then(data => {
        if (!data || !data.Metric) {
          console.error("Invalid response format");
          return;
        }


        const metricEntries = Object.entries(data.Metric);
        if (metricEntries.length === 0) {
          console.error("No metric data available");
          return;
        }

        // Extract the latest available date dynamically
        const availableDates = Object.values(data.Metric)
          .map(item => Object.keys(item).filter(key => key !== "change"))
          .flat();

        const latest = availableDates.length ? availableDates[0] : null;
        setLatestDate(latest);

        // Convert API data into a list format
        const allowedMetricsForCard = ['Basic EPS', 'Debt Equity Ratio','Profit Loss','Interest Service Coverage Ratio','Debt Service Coverage Ratio'];
        const allowedMetricsForPie = ['Current Assets', 'Fixed Assets','Goodwill','Investments','Advances','Assets'];

        const metricList = Object.entries(data.Metric)
            .filter(([title]) => allowedMetricsForCard.includes(title)) // Filter only allowed titles
            .map(([title, data]) => ({
          title,
          value: data[latest], // Extract the latest available value
          change: data.change
        }));
        setMetrics(metricList);

        let metricListPie = Object.fromEntries(
                  Object.entries(data.Asset).filter(([key]) => allowedMetricsForPie.includes(key))
                );
        console.log("BEFORE",metricListPie);

        metricListPie = transformData(metricListPie);
        console.log("AFTER",metricListPie);
        setMetricListPie(metricListPie);

        let metricListEPS = JSON.parse(data.detailed_data).data[0].splice(1);
        metricListEPS = metricListEPS.map(parseFloat)
        setMetricListSl(metricListEPS);
        console.log("metricListEPS",metricListEPS);
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);



    return (
        <div style={styles.teaserBoard}>
            {/*<div style={styles.metricSection}>*/}
                <DisplayCards cardList={metrics}/>
            {/*</div>*/}

            <div style={styles.chartsSection}>
                {metricListPie.length > 0 ?
                <AssetDonutChart assetList={metricListPie}/>
                    : ""}
                {/*{metricListSl.length > 0 ?*/}
                {/*<Sparklines data={metricListSl}>*/}
                {/*            <SparklinesLine color="blue" />*/}
                {/*</Sparklines>*/}
                {/* : ""}*/}
                {/*<StockPriceChart data={stockPrice}/>*/}
            </div>

            {/*<div style={styles.viewMore}>*/}
            {/*    <button*/}
            {/*        style={styles.viewMoreButton}*/}
            {/*        onMouseOver={(e) => (e.target.style.background = styles.viewMoreButtonHover.background)}*/}
            {/*        onMouseOut={(e) => (e.target.style.background = styles.viewMoreButton.background)}*/}
            {/*        onClick={() => navigate(`/fd/${symbol}`)}*/}
            {/*    >*/}
            {/*        View Full Dashboard*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
}

export default FundaTeaser;

const styles = {
  teaserBoard: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    // justifyContent: "space-between",
    flexDirection: "column", // Ensures elements stack vertically
    alignItems: "center", // Centers all child elements
    justifyContent: "center",
    width: "100%",
    padding: "20px",
    background: "#f8f9fa",
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
  metricSection: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    flex: 2,
  },
  metricCard: {
    flex: "1 1 calc(33.33% - 16px)", // 3 cards per row
    minWidth: "200px",
    padding: "12px",
    borderRadius: "8px",
    background: "white",
    boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    fontSize: "14px",
  },
  positive: {
    backgroundColor: "#e6f7e6", // Light green for positive change
  },
  negative: {
    backgroundColor: "#fce8e8", // Light red for negative change
  },
  chartsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    flexWrap: "wrap",
    marginBottom: "20px", // Creates space before the button
  },
    viewMore: {
    display: "flex",
    justifyContent: "center", // Centers the button horizontally
    alignItems: "center",
    marginTop: "20px", // Space from content above
    width: "100%", // Ensure it spans full width of container
  },
  viewMoreButton: {
    background: "#007bff",
    color: "#fff",
    padding: "10px 20px",
    width:"20%"  ,
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s",
  },
  viewMoreButtonHover: {
    background: "#0056b3",
  },
};
